export default __webpack_public_path__ + "static/media/policy_car_query.9f46381f.png";